import EmptyTokenImg from '../../components/EmptyTokenImg';

export default function Header({data}) {
  return (
    <div className="container py-3">
      <div className="d-lg-flex align-items-center">
        <div className="mb-3 mb-lg-0">
          <h1 className="h4 media align-items-center text-dark">
            <EmptyTokenImg className="u-sm-avatar mr-2" />
            <div className="media-body">
              Token <span className="text-secondary small">{data.token_name}</span>
            </div>
          </h1>
          <div className="mt-1">
            <a
              className="u-label u-label--xs u-label--secondary"
              href="/tokens/label/mova-pegged"
              data-toggle="tooltip"
              data-title="Wrapped tokens that are backed by tokens vaults in Mova."
              data-original-title=""
              title=""
            >
              {data.token_name} <i className="fa fa-info-circle text-secondary ml-1"></i>
            </a>
            &nbsp;
          </div>
        </div>

        <div className="d-flex flex-wrap ml-lg-auto"></div>
      </div>
    </div>
  );
}
